import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * パスワード変更要求API
 */
export const requestForChange = (params = {}) => {
  const defaults = {
    _path: 'PW/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 新パスワード登録API
 */
export const registerNew = (params = {}) => {
  const defaults = {
    _path: 'PW/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
